module.exports = __webpack_public_path__ + "static/media/table.682b983f.png";